'use client';

import { createContext, useContext } from 'react';

import { brandForLocale, FALLBACK_BRAND, type PublicBrand, type ResolvedContact } from '@/lib/public-brand';
import { useLocale } from '@/lib/i18n';

const PublicBrandContext = createContext<PublicBrand>(FALLBACK_BRAND);

export function PublicBrandProvider({
  brand,
  children,
}: {
  brand: PublicBrand;
  children: React.ReactNode;
}) {
  return <PublicBrandContext.Provider value={brand}>{children}</PublicBrandContext.Provider>;
}

export function usePublicBrand(): ResolvedContact {
  const brand = useContext(PublicBrandContext);
  const { lang } = useLocale();
  return brandForLocale(brand, lang);
}
